// extracted by mini-css-extract-plugin
export default {"product-list":"ProductList_product-list__x-eRd","content":"ProductList_content__N9I-L","list":"ProductList_list__T0gj1"};